/**
 * Helper function to detect if there is an internet connection
 * @return boolean that will be true if there is an internet connection
 */
const getIsOnline = ():boolean => window.navigator.onLine;

// eslint-disable-next-line import/prefer-default-export
export { getIsOnline };
